module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921041149_T.fcdac3ef.jpg";